<script setup lang="ts">
/** Aura Incorporation — Share Application Form (신버전: 주주 식별·연락처 확장). */
import CddVarField from './cdd/CddVarField.vue';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <div class="doc-lbl-title">SHARE APPLICATION FORM</div>
    <p class="doc-p"><b>Date:</b></p>
    <p class="doc-p">The Secretary<br />
      <CddVarField field-key="company_name" label="Company Name" /><br />
      <CddVarField field-key="registered_office_address" label="Registered Office Address" />
    </p>
    <p class="doc-p">Dear Sir/Madam,</p>
    <p class="doc-p"><b>APPLICATION FOR SHARES IN <CddVarField field-key="company_name" label="Company Name" /> (&ldquo;the Company&rdquo;)</b></p>
    <p class="doc-p">I hereby apply for an allotment of shares in the company and provide the following information:</p>

    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Full Name</td><td><CddVarField field-key="shareholder_name" label="Shareholder Name" /></td></tr>
        <tr><td class="cdd-lcell">Identification Number</td><td><CddVarField field-key="shareholder_identification_no" label="Identification Number" /></td></tr>
        <tr><td class="cdd-lcell">Identification Type</td><td><CddVarField field-key="shareholder_identification_type" label="Identification Type" /></td></tr>
        <tr><td class="cdd-lcell">Nationality / Place of incorporation</td><td><CddVarField field-key="shareholder_nationality" label="Nationality / Place of incorporation" /></td></tr>
        <tr><td class="cdd-lcell">Registered / Residential Address</td><td><CddVarField field-key="shareholder_residential_address" label="Residential Address" /></td></tr>
        <tr><td class="cdd-lcell">Contact Address</td><td><CddVarField field-key="shareholder_contact_address" label="Contact Address" /></td></tr>
        <tr><td class="cdd-lcell">Email Address</td><td><CddVarField field-key="shareholder_email_address" label="Email Address" /></td></tr>
        <tr><td class="cdd-lcell">Mobile Number</td><td><CddVarField field-key="shareholder_contact_number" label="Mobile Number" /></td></tr>
      </tbody>
    </table>

    <p class="doc-sec-title" style="text-align:left">Share Allotment Details</p>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Number of Shares</td><td><CddVarField field-key="number_of_shares" label="Number of Shares" /></td></tr>
        <tr><td class="cdd-lcell">Class of Shares</td><td><CddVarField field-key="type_of_shares" label="Class of Shares" /></td></tr>
        <tr><td class="cdd-lcell">Total Amount Payable</td><td><CddVarField field-key="total_amount_payable" label="Total Amount Payable" /></td></tr>
        <tr><td class="cdd-lcell">Currency</td><td><CddVarField field-key="currency" label="Currency" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p" style="margin-top:10px">I hereby agree to be bound by the Constitution of the company.</p>
    <p class="doc-p">Yours faithfully</p>
    <p class="doc-p"><CddVarField field-key="shareholder_signature" label="Shareholder Signature" /></p>
  </div>
</template>
